import React from "react";
import "../../../css/table.css";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { toArray, orderBy, values } from "lodash";
import GoalForm from "../../../forms/GoalForm.jsx";
import Modal from "../../../components/Modal/Modal.jsx";
import { db } from "../../../services/firebase";
import { resetForm } from "../../../ducks/Forms";
import SweetAlert from "react-bootstrap-sweetalert";
import IndicatorForm from "../../../forms/IndicatorForm.jsx";
import NotificationSystem from "react-notification-system";
import Button from "../../../elements/CustomButton/CustomButton.jsx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import SweetSpinner from "../../../components/SweetSpinner/SweetSpinner.jsx";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { style as NotifyStyle } from "../../../variables/Variables.jsx";
import {
  faPencilAlt,
  faTrash,
  faTrophy,
} from "@fortawesome/fontawesome-free-solid";

class Indicators extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;

    this.state = {
      fetchingIndicators: true,
      indicatorModal: false,
      goalModal: false,
      targetIndicator: null,
      indicators: {},
      alert: null,
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this._fetchIndicators();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    return (
      <div>
        {this.state.alert}
        {this.indicatorModal()}
        {this.goalModal()}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Row>
          <Col md={12}>
            <Button
              bsStyle="default"
              wd
              className="pull-right"
              style={{ marginBottom: 10 }}
              onClick={() => {
                this.props.resetForm("IndicatorForm");
                this.setState({ indicatorModal: true, targetIndicator: null });
              }}
            >
              Adicionar Indicador
            </Button>
          </Col>
        </Row>
        {this._renderIndicatorsTable(this.state.indicators)}
      </div>
    );
  }

  _fetchIndicators = () => {
    const { companyID } = this.props;
    this.setState({ fetchingIndicators: true });
    db.collection("companies")
      .doc(companyID)
      .collection("indicators")
      .onSnapshot((indicatorSnapshot) => {
        if (!indicatorSnapshot.empty) {
          const indicators = [];
          indicatorSnapshot.forEach((indicator) => {
            db.collection("companies")
              .doc(companyID)
              .collection("products")
              .doc(indicator.data().product)
              .get()
              .then((product) => {
                indicators.push({
                  ...indicator.data(),
                  id: indicator.id,
                  productName: product.data().name,
                  goal:
                    indicator.data().goal > 0
                      ? indicator.data().goal
                      : "Indefinida",
                  status: indicator.data().status,
                });
                this.setState({ indicators });
              })
              .catch((e) => console.log(e));
          });
          this.setState({ fetchingIndicators: false });
        } else {
          this.setState({ fetchingIndicators: false });
        }
      });
  };

  _setIndicator = (values) => {
    this.setState({ indicatorModal: false });
    this.waitAlert("Salvando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("indicators")
      .add({
        name: values.name,
        product: values.product.value,
        goal: 0,
        details: values.details,
        tables: values.tables,
        status: values.status,
      })
      .then(() => {
        this.hideAlert();
        this.notify("Indicador adicionado", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao adicionar indicador", "error");
      });
  };

  _updateIndicator = (indicatorID) => (values) => {
    console.log(indicatorID);
    this.setState({ indicatorModal: false });
    this.waitAlert("Atualizando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("indicators")
      .doc(indicatorID)
      .update({
        name: values.name,
        details: values.details,
        product:
          typeof values.product === "object"
            ? values.product.value
            : values.product,
        tables: values.tables,
        status: values.status,
      })
      .then(() => {
        this.hideAlert();
        this.notify("Indicador atualizado", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao atualizar indicador", "error");
      });
  };

  _updateGoal = (indicatorID) => (values) => {
    this.setState({ goalModal: false });
    this.waitAlert("Atualizando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("indicators")
      .doc(indicatorID)
      .update({
        goal: Number(values.goal.replace(/,/g, ".")),
      })
      .then(() => {
        this.hideAlert();
        this.notify("Meta definida", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao definir meta", "error");
      });
  };

  _remove = (id) => {
    this.hideAlert();
    this.waitAlert("Validando dados, aguarde", false);

    const { companyID } = this.props;

    db.collection("companies")
      .doc(companyID)
      .collection("results")
      .where("indicator", "==", id)
      .get()
      .then((snap) => {
        if (snap.empty) {
          this.hideAlert();
          this.waitAlert("Removendo, aguarde", false);
          db.collection("companies")
            .doc(companyID)
            .collection("indicators")
            .doc(id)
            .delete()
            .then(() => {
              this.hideAlert();
              this.notify("Indicador removido", "success");
            })
            .catch((e) => {
              this.hideAlert();
              this.notify("Erro ao remover indicador", "error");
            });
        } else {
          this.hideAlert();
          this.notify(
            "Este indicador possui ligações com os dados da empresa e não pode ser removido.",
            "warning"
          );
        }
      });
  };

  indicatorModal = () => {
    const { targetIndicator } = this.state;
    return (
      <Modal
        title={targetIndicator ? "Atualizar indicador" : "Adicionar indicador"}
        isOpen={this.state.indicatorModal}
        content={
          <IndicatorForm
            initialValues={targetIndicator}
            companyID={this.props.companyID}
            onSubmit={(values) => {
              targetIndicator
                ? this._updateIndicator(targetIndicator.id)(values)
                : this._setIndicator(values);
            }}
            handleCancel={() =>
              this.setState({ indicatorModal: false, targetIndicator: null })
            }
          />
        }
      />
    );
  };

  goalModal = () => {
    const { targetIndicator } = this.state;
    return (
      <Modal
        title="Definir meta"
        isOpen={this.state.goalModal}
        content={
          <div>
            <GoalForm
              initialValues={targetIndicator}
              company={this.state.company}
              onSubmit={(values) =>
                this._updateGoal(targetIndicator.id)(values)
              }
              handleCancel={() =>
                this.setState({ goalModal: false, targetIndicator: null })
              }
            />
          </div>
        }
      />
    );
  };

  _renderIndicatorsTable = (data) => (
    <ReactTable
      columns={[
        { Header: "Produto", accessor: "productName" },
        { Header: "Nome", accessor: "name" },
        { Header: "Instruções de coleta", accessor: "details" },
        { Header: "Meta (em gramas)", accessor: "goal" },
        { Header: "Status", accessor: "status.label" },
        {
          Header: "Ações",
          accessor: "",
          Cell: ({ value }) => (
            <div style={{ textAlign: "center" }}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`edit_${value.id}`}>Definir Meta</Tooltip>
                }
              >
                <a
                  className="btn btn-simple btn-default btn-icon"
                  onClick={() =>
                    this.setState({ targetIndicator: value, goalModal: true })
                  }
                >
                  <FontAwesomeIcon className="text-dark" icon={faTrophy} />
                </a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-default btn-icon"
                  onClick={() =>
                    this.setState({
                      targetIndicator: value,
                      indicatorModal: true,
                    })
                  }
                >
                  <FontAwesomeIcon className="text-dark" icon={faPencilAlt} />
                </a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-danger btn-icon"
                  onClick={() => this.removeAlert(value.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </a>
              </OverlayTrigger>
            </div>
          ),
        },
      ]}
      data={toArray(data)}
      defaultSorted={[
        {
          id: "status.label",
          desc: false,
        },
        {
          id: "productName",
          desc: false,
        },
      ]}
      onFetchData={this._fetchIndicators}
      loading={this.state.fetchingIndicators}
      defaultPageSize={10}
      className="-striped -highlight"
      previousText="Anterior"
      nextText="Próximo"
      loadingText="Carregando"
      noDataText="Nenhum indicador encontrado"
      pageText="Página"
      ofText="de"
      rowsText="Registros"
    />
  );

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  removeAlert = (id) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() => this._remove(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          cancelBtnBsStyle="warning"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        />
      ),
    });
  };

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };
}

export default connect(null, { resetForm })(Indicators);



// WEBPACK FOOTER //
// ./src/views/Companies/Tabs/Indicators.jsx